import React from 'react';
import { translate } from 'react-i18next';

class EsotericRadioButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      checked: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: this.props.checked,
    });
  }

  handleChange(e) {
    const checked = !this.state.checked;
    this.setState({
      checked,
      currentPreference: this.props.preference,
    });
    this.props.onSettingsChange(this.props.name, this.props.preference);
  }

  render() {
    const label = this.props.t(`EsotericRadioButton.${this.props.preference}`);
    let current;
    const checked = false;
    let checkedClass = '';
    if (this.props.currentPreference) {
      current = this.props.currentPreference.callout_notification_preferences;
    }

    if (this.props.checked) {
      checkedClass = 'checked';
    }

    const enabledClass = this.props.disabled ? 'disabled' : '';

    return (
      <div className={enabledClass}>
        <label className={checkedClass}>
          <input
            type="radio"
            disabled={this.props.disabled}
            name={this.props.name}
            className={this.props.preference}
            onChange={this.handleChange.bind(this)}
            checked={this.state.checked}
            value={this.props.preference}
          />
          {label}
        </label>
        {this.props.disabled && this.props.validationMessage}
      </div>
    );
  }
}

export default translate()(EsotericRadioButton);
